import styled from 'styled-components';
import { designTokens } from '../foundation/DesignTokens';

// Switch container
export const SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
`;

// Hidden checkbox input
export const SwitchInput = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
`;

// Slider background
export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${designTokens.colors.gray[300]};
  transition: all 0.3s ease;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: all 0.3s ease;
    border-radius: 50%;
    box-shadow: ${designTokens.shadows.sm};
  }

  ${SwitchInput}:checked + & {
    background-color: ${designTokens.colors.primary[500]};
  }

  ${SwitchInput}:checked + &:before {
    transform: translateX(20px);
  }

  ${SwitchInput}:disabled + & {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${SwitchInput}:focus + & {
    box-shadow: 0 0 0 3px ${designTokens.colors.primary.ring};
  }
`;

// Settings row for toggle configurations
export const SettingsRow = styled.div`
  padding: ${designTokens.spacing.xl};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid ${designTokens.colors.gray[100]};
  gap: ${designTokens.spacing.lg};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 900px) {
    padding: ${designTokens.spacing.lg};
    flex-direction: column;
    align-items: flex-start;
  }
`;

// Info section for settings
export const SettingInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// Setting title
export const SettingTitle = styled.h4`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${designTokens.colors.gray[900]};
  font-family: ${designTokens.fonts.body};

  @media (max-width: 900px) {
    font-size: 0.95rem;
  }
`;

// Setting description
export const SettingDescription = styled.p`
  margin: 0;
  color: ${designTokens.colors.gray[500]};
  font-size: 0.9rem;
  max-width: 600px;
  line-height: 1.5;

  @media (max-width: 900px) {
    font-size: 0.85rem;
    max-width: 100%;
  }
`;

export default SwitchContainer;
